import { render, staticRenderFns } from "./MaterialPlan.vue?vue&type=template&id=fbb8c898&scoped=true&"
import script from "./MaterialPlan.vue?vue&type=script&lang=js&"
export * from "./MaterialPlan.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPlan.vue?vue&type=style&index=0&id=fbb8c898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb8c898",
  null
  
)

export default component.exports